import React, { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';
import loadable from '@loadable/component';
import leafFlutteringInWind from 'assets/images/leaf-fluttering-in-wind.png';
import sneezingFace from 'assets/images/sneezing-face.png';
import baby from 'assets/images/baby.png';
import dogFace from 'assets/images/dog-face.png';
import construction from 'assets/images/construction.png';
import woman from 'assets/images/woman.png';
import explodingHead from 'assets/images/exploding-head.png';
import theBasicBreatherCrop from 'assets/images/the-basic-breather-crop.png';
import theBasicBreatherCropWebp from 'assets/images/the-basic-breather-crop.png?as=webp';
import theRookieParentCrop from 'assets/images/the-rookie-parent-crop.png';
import theRookieParentCropWebp from 'assets/images/the-rookie-parent-crop.png?as=webp';
import theMamaToBeCrop from 'assets/images/the-mama-to-be-crop.png';
import theMamaToBeCropWebp from 'assets/images/the-mama-to-be-crop.png?as=webp';
import theHomeWreckerCrop from 'assets/images/the-home-wrecker-crop.png';
import theHomeWreckerCropWebp from 'assets/images/the-home-wrecker-crop.png?as=webp';
import theBigSneezeCrop from 'assets/images/the-big-sneeze-crop.png';
import theBigSneezeCropWebp from 'assets/images/the-big-sneeze-crop.png?as=webp';
import theCritterCuddlerCrop from 'assets/images/the-critter-cuddler-crop.png';
import theCritterCuddlerCropWebp from 'assets/images/the-critter-cuddler-crop.png?as=webp';
import theOverreactorCrop from 'assets/images/the-overreactor-crop.png';
import theOverreactorCropWebp from 'assets/images/the-overreactor-crop.png?as=webp';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

const LazyImg = loadable(() => import('../common/LazyImg'));
const FadeIn = loadable(() => import('../common/FadeIn'));

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const slideData = [
  {
    color: '#8852F6',
    link: '/filters/rookie-parent',
    infoIcon: {
      src: `${baby}`,
      alt: 'baby',
    },
    title: 'Rookie Parent',
    description: 'Making the air clean and safe for your littles',
    productImg: {
      defaultSrc: `${theRookieParentCrop}`,
      webpSrc: `${theRookieParentCropWebp}`,
      alt: 'The Rookie Parent',
    },
  },

  {
    color: '#1CE4D5',
    link: '/filters/mama-to-be',
    infoIcon: {
      src: `${woman}`,
      alt: 'woman',
    },
    title: 'Mama-to-Be',
    description: 'Extra protection when you’re breathing for two',
    productImg: {
      defaultSrc: `${theMamaToBeCrop}`,
      webpSrc: `${theMamaToBeCropWebp}`,
      alt: 'The mama to be',
    },
  },

  {
    color: '#F47F0F',
    link: '/filters/home-wrecker',
    infoIcon: {
      src: `${construction}`,
      alt: 'construction',
    },
    title: 'Home Wrecker',
    description: 'Protecting you from that “New Home” smell',
    productImg: {
      defaultSrc: `${theHomeWreckerCrop}`,
      webpSrc: `${theHomeWreckerCropWebp}`,
      alt: 'The home wrecker',
    },
  },
  {
    color: '#FFCA0C',
    link: '/filters/big-sneeze',
    infoIcon: {
      src: `${sneezingFace}`,
      alt: 'sneezing face',
    },
    title: 'Big Sneeze',
    description: 'Helping you fight back against allergens',
    productImg: {
      defaultSrc: `${theBigSneezeCrop}`,
      webpSrc: `${theBigSneezeCropWebp}`,
      alt: 'The big sneeze',
    },
  },

  {
    color: '#F42D53',
    link: '/filters/critter-cuddler',
    infoIcon: {
      src: `${dogFace}`,
      alt: 'dog face',
    },
    title: 'Critter Cuddler',
    description: 'Clearing the air for fur families',
    productImg: {
      defaultSrc: `${theCritterCuddlerCrop}`,
      webpSrc: `${theCritterCuddlerCropWebp}`,
      alt: 'The Critter Cuddler',
    },
  },

  {
    color: '#3E4649',
    link: '/filters/basic-breather',
    infoIcon: {
      src: `${leafFlutteringInWind}`,
      alt: 'Leaf fluttering in wind',
    },
    title: 'Basic Breather',
    description: 'For the everyday lover of clean air',
    productImg: {
      defaultSrc: `${theBasicBreatherCrop}`,
      webpSrc: `${theBasicBreatherCropWebp}`,
      alt: 'The basic breather',
    },
  },
  {
    color: '#0A56EA',
    link: '/filters/overreactor',
    infoIcon: {
      src: `${explodingHead}`,
      alt: 'exploding head',
    },
    title: 'Overreactor',
    description: 'Protection from ALL the things',
    productImg: {
      defaultSrc: `${theOverreactorCrop}`,
      webpSrc: `${theOverreactorCropWebp}`,
      alt: 'The overreactor',
    },
  },
];

const NextArrow = props => {
  const { className, onClick } = props;

  return (
    <button type='button' className={`${className} filter-card__slide-next`} onClick={onClick} aria-label='go to next slide'>
      <svg className='icon icon-circle-right-arrow'><use xlinkHref='#icon-circle-right-arrow' /></svg>
      <span className='screen-reader-text'>go to next slide</span>
    </button>
  );
};

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PrevArrow = props => {
  const { className, onClick } = props;

  return (
    <button type='button' className={`${className} filter-card__slide-prev`} onClick={onClick} aria-label='go to previous slide'>
      <svg className='icon icon-circle-left-arrow'><use xlinkHref='#icon-circle-left-arrow' /></svg>
      <span className='screen-reader-text'>go to previous slide</span>
    </button>
  );
};

/**
 * @param dots
 * @returns {JSX.Element}
 * @constructor
 */

/**
 * @param settings
 * @returns {JSX.Element}
 * @constructor
 */

const FilterCardSlider = ({ settings, sliderRef }) => (
  <Slider {...settings} className='filter-card__slider' ref={sliderRef}>
    {
      slideData.map(props => {
        const {
          link, color, infoIcon, title, description, productImg,
        } = props;
        return (
          <div className='filter-card__slide-item'>
            <Link
              to={link}
              style={{ color: `${color}` }}
              key={title}
            >
              <h3 className='filter-card__slide-title' style={{ color: `${color}` }}>
                The
                <LazyImg
                  src={infoIcon.src}
                  alt={infoIcon.alt}
                />
                {' '}
                <br />
                {title}
              </h3>
              <p className='filter-card__slide-description'>
                {description}
              </p>
              <figure className='filter-card__slide-image'>
                <LazyLoad>
                  <FadeIn>
                    <picture>
                      <source srcSet={productImg.webpSrc} type='image/webp' />
                      <source srcSet={productImg.defaultSrc} type='image/png' />
                      <img
                        src={productImg.defaultSrc}
                        alt={productImg.alt}
                      />
                    </picture>
                  </FadeIn>
                </LazyLoad>
              </figure>
            </Link>
          </div>
        );
      })
    }
  </Slider>
);

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FilterCard = props => {
  const { page } = props;
  const sliderRef = useRef(null);
  const [ currentIndex, setCurrentIndex ] = useState(null);
  const dotsRef = useRef(null);

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: page === undefined,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    appendDots: dots => (<ul ref={dotsRef}>{dots}</ul>),

    onInit() {
      setCurrentIndex(0);
    },

    beforeChange: (currentIdx, nextIdx) => {
      setCurrentIndex(nextIdx);
    },

    responsive: [{
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    }],
  };

  useEffect(() => {
    if (dotsRef?.current === null) return;
    dotsRef.current.style.color = `${slideData[currentIndex].color}`;
  }, [ currentIndex ]);

  return (
    <div className='filter-card'>
      <h2 className='filter-card__title'>
        {page !== undefined ? 'Discover Mila’s other filters:' : 'Discover our other filters:'}
      </h2>
      <FilterCardSlider settings={settings} sliderRef={sliderRef} />
    </div>
  );
};

export default FilterCard;
